import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../../utils/colors';
import { useRandomLinkColors } from '../../utils/useRandomLinkColors';
const Navigation = () => {
  // Use our custom hook
  useRandomLinkColors();
  return <ul className="list-none space-y-4" data-id="element-479">
      <li className="flex" data-id="element-480">
        <span className="mr-2" data-id="element-481">↑</span>
        <Link to="/info" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-482">
          About
        </Link>
      </li>
      <li className="flex" data-id="element-483">
        <span className="mr-2" data-id="element-484">↑</span>
        <Link to="/photographs" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-485">
          Photographs
        </Link>
      </li>
      <li className="flex" data-id="element-486">
        <span className="mr-2" data-id="element-487">↑</span>
        <Link to="/writing" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-488">
          Writing
        </Link>
      </li>
      <li className="flex" data-id="element-489">
        <span className="mr-2" data-id="element-490">↑</span>
        <Link to="/books" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-491">
          Books
        </Link>
      </li>
      <li className="flex" data-id="element-492">
        <span className="mr-2" data-id="element-493">↑</span>
        <Link to="/workshops" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-494">
          Workshops
        </Link>
      </li>
      <li className="flex" data-id="element-495">
        <span className="mr-2" data-id="element-496">↑</span>
        <Link to="/contact" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-497">
          Contact
        </Link>
      </li>
    </ul>;
};
export default Navigation;